module.exports = __webpack_public_path__ + "img/aquafeed.73208e44.png";